import { useCallback, useEffect, useState } from 'react';
import { fetchRecommendedCarCatalogApi } from '@/api/carApi';
import { RecommendedCarCatalogData } from '@/types/api/recommendedCarCatalogApi';

interface UseRecommendedCarCatalogProps {
  mkCd?: string;
  carnmCd?: string;
}

export const useRecommendedCarCatalog = ({
  mkCd,
  carnmCd,
}: UseRecommendedCarCatalogProps) => {
  const [data, setData] = useState<RecommendedCarCatalogData | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const fetch = useCallback(async () => {
    if (!mkCd || !carnmCd) return;

    setIsLoading(true);
    setErrorMessage(null);

    try {
      const response = await fetchRecommendedCarCatalogApi(mkCd, carnmCd);
      const { data: resData } = response as unknown as {
        data: {
          data?: RecommendedCarCatalogData;
          success: boolean;
          error_message?: string;
        };
      };

      if (resData?.success && resData.data) {
        setData(resData.data);
      } else {
        setErrorMessage(
          resData?.error_message ?? 'おすすめ車種詳細の取得に失敗しました',
        );
      }
    } catch (error) {
      console.error(error);
      setErrorMessage('おすすめ車種詳細の取得に失敗しました');
    } finally {
      setIsLoading(false);
    }
  }, [mkCd, carnmCd]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return { data, isLoading, errorMessage } as const;
};
